var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurplepencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_1229_11807)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1229_11807",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1229_11807",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1229_11807",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC30lEQVR4nO2dv24TQRCHr0IggYgEBQ0t1NRIQEFPAykQL0Ao7FkTGYmb2TQgav4UCFGk4C0QQhE8As8Q0QSCEPJsikXnQEDkbM53e55T7vdJ2+WS9feb9Y5HUZJlAAAAAAAAAAAOyIe6yqQf2ekuU/gkpI+8j8f/fAVoDXHBiwvx8NItvxZPtveTQcakG+Xy91dxKtbX4ynrffZSviAEe/kIoQPyEUIH5COEDshHCA0RCuMUASCEBiCEDoAQjtB9sL90C2ML4xDY6eM6e+g9kujtqBjgWb+WzlQ1k24s+kyCE7Cb9R3+S+TyQ9APWZ/hEoHLDMGPJjezvsJzxC0pBJ/1Fa4gjJ0+afFihnypdkm2EQLky2KdSsoQIF/qtYspQoB8abAahgD5kmDV6Y4WfeZIwUmHZ/VOQm/hFuQjhA7IRwgdkI8QOiAfIXRAPkLogPxfC32+QP7yYci3gyHfDoZ8Oxjy7WDIt4Mh3w6GfDsY8u1gyLcD8g2BfEMg3xDINwTyDYF8QyDfEMg3BPINgXxDIN8Y7+Mx7yYXxOktcWGTnX5Zlnzu8y/KzsIP4opQeAX5xrQZAkN+1ZOgXyHfEHHhDS5cQ3LSO6h8Q3Knl1D5hngXz4rTCSo/ATnpbR6Gy3Wefeh+nOfh5IZQeC2kO5BfAyZ9KqTf6obwm/E4nq7SokL+Pwjp26mcBCEUzAsB8ktg0u0DSQlC8IO4Uja2gPwSHtyLZw5VKul3P9q71uT7igub6HYq4EfhSunbRcOTkA91FZVfAXHh7swLs8FJyAeTi6j8CojTZ3O7lpongSieQOVXQJy++2/fnuBOADNg0s+VPjwhhLbGCQuMDxBCWpjC1YVnOAghHUxhrdYgDSGkgUmfLzi93C7GFsXsqBjgJdpGfxGn72dU+E7xp3qFwktxYeCHe9f9/XjOer9Hjum/9Ju2ofqi+EBW3AnFxWy9LwAAAAAAAAAAAAAAso7zE6WuGW4tZjbxAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplepencilIcon);
export default __webpack_public_path__ + "static/media/purplepencilIcon.1beae65c836644c678a1c4ddf22fdc65.svg";
export { ForwardRef as ReactComponent };